import { render } from "./PaymentConfirm.vue?vue&type=template&id=00be8c13&scoped=true"
import script from "./PaymentConfirm.vue?vue&type=script&lang=js"
export * from "./PaymentConfirm.vue?vue&type=script&lang=js"

import "./PaymentConfirm.vue?vue&type=style&index=0&id=00be8c13&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00be8c13"]])

export default __exports__